<div class="min-h-screen bg-gray-50/50 p-6 md:p-12 md:pt-8 font-sans">
    
    <!-- Header Section (Old Design Maintained) -->
    <div class="max-w-7xl mx-auto mb-8">
        <a routerLink="/admin-dashboard" class="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-gray-800 transition mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
            Back to Dashboard
        </a>
        <div class="flex flex-col md:flex-row justify-between items-start md:items-end gap-6">
            <div>
                <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">Category Wise Report</h1>
            </div>
            <div class="flex gap-4 overflow-x-auto w-full md:w-auto">
                <div *ngFor="let stat of stats" class="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-center gap-3 min-w-[180px]">
                    <div [class]="'w-10 h-10 rounded-full flex items-center justify-center text-xl ' + stat.color">{{ stat.icon }}</div>
                    <div>
                        <p class="text-xs text-gray-500 font-bold uppercase">{{ stat.label }}</p>
                        <p class="text-lg font-bold text-gray-900">{{ stat.value }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Filter Tabs (Enhanced with new categories) -->
    <div class="max-w-7xl mx-auto mb-6 flex flex-wrap gap-2">
        <div class="bg-white p-1 rounded-xl shadow-sm border border-gray-100 inline-flex">
            <button (click)="setTab('all')" [class.bg-gray-800]="activeTab === 'all'" [class.text-white]="activeTab === 'all'" class="px-4 py-2 rounded-lg text-xs font-bold transition-all">All Views</button>
            <button (click)="setTab('ready_piece')" [class.bg-orange-500]="activeTab === 'ready_piece'" [class.text-white]="activeTab === 'ready_piece'" class="px-4 py-2 rounded-lg text-xs font-bold transition-all">💎 Piece Wise</button>
            <button (click)="setTab('ready_lot')" [class.bg-purple-600]="activeTab === 'ready_lot'" [class.text-white]="activeTab === 'ready_lot'" class="px-4 py-2 rounded-lg text-xs font-bold transition-all">📦 Lot Wise</button>
            <button (click)="setTab('products')" [class.bg-green-600]="activeTab === 'products'" [class.text-white]="activeTab === 'products'" class="px-4 py-2 rounded-lg text-xs font-bold transition-all">🏷️ Products</button>
            <button (click)="setTab('assembly')" [class.bg-blue-600]="activeTab === 'assembly'" [class.text-white]="activeTab === 'assembly'" class="px-4 py-2 rounded-lg text-xs font-bold transition-all">⚒️ Assembly</button>
        </div>
    </div>

    <!-- MAIN GRID CONTENT -->
    <div class="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8">

        <!-- 1. Ready Piece Wise -->
        <div *ngIf="showPiece" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-orange-500 rounded-full"></span> Ready: Piece Wise
            </h3>
            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table class="w-full text-left text-xs">
                    <thead class="bg-gray-50 border-b border-gray-100 text-[10px] uppercase text-gray-500 font-bold">
                        <tr><th class="px-5 py-4">Item</th><th class="px-5 py-4 text-right">Net Wt.</th><th class="px-5 py-4 text-right">Amount</th></tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of getPaginatedData(readyPieceSales, pages.piece)" class="hover:bg-orange-50/30 transition-colors">
                            <td class="px-5 py-4"><p class="font-bold text-gray-800">{{item.name}}</p><span class="text-[9px] text-gray-400 uppercase">{{item.barcode}}</span></td>
                            <td class="px-5 py-4 text-right">{{item.weight}}</td>
                            <td class="px-5 py-4 text-right font-bold text-gray-900">{{item.amount}}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- Pagination Footer -->
                <div class="p-4 bg-gray-50 border-t flex justify-between items-center text-[10px] font-bold text-gray-500">
                    <span>Page {{pages.piece}} of {{getTotalPages(readyPieceSales)}}</span>
                    <div class="flex gap-2">
                        <button [disabled]="pages.piece === 1" (click)="changePage('piece', -1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Prev</button>
                        <button [disabled]="pages.piece >= getTotalPages(readyPieceSales)" (click)="changePage('piece', 1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Next</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2. Ready Lot Wise -->
        <div *ngIf="showLot" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-purple-600 rounded-full"></span> Ready: Lot Wise
            </h3>
            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table class="w-full text-left text-xs">
                    <thead class="bg-gray-50 border-b border-gray-100 text-[10px] uppercase text-gray-500 font-bold">
                        <tr><th class="px-5 py-4">Lot Details</th><th class="px-5 py-4 text-right">Net Wt.</th><th class="px-5 py-4 text-right">Amount</th></tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of getPaginatedData(readyLotSales, pages.lot)" class="hover:bg-purple-50/30">
                            <td class="px-5 py-4"><p class="font-bold text-gray-800">{{item.name}}</p><span class="text-[9px] text-gray-400 uppercase">{{item.barcode}}</span></td>
                            <td class="px-5 py-4 text-right">{{item.weight}}</td>
                            <td class="px-5 py-4 text-right font-bold text-gray-900">{{item.amount}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="p-4 bg-gray-50 border-t flex justify-between items-center text-[10px] font-bold text-gray-500">
                    <span>Page {{pages.lot}} of {{getTotalPages(readyLotSales)}}</span>
                    <div class="flex gap-2">
                        <button [disabled]="pages.lot === 1" (click)="changePage('lot', -1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Prev</button>
                        <button [disabled]="pages.lot >= getTotalPages(readyLotSales)" (click)="changePage('lot', 1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Next</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3. Standard Products -->
        <div *ngIf="showProduct" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-green-600 rounded-full"></span> Standard Products
            </h3>
            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table class="w-full text-left text-xs">
                    <thead class="bg-gray-50 border-b border-gray-100 text-[10px] uppercase text-gray-500 font-bold">
                        <tr><th class="px-5 py-4">Product</th><th class="px-5 py-4 text-right">Purity</th><th class="px-5 py-4 text-right">Amount</th></tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of getPaginatedData(productSales, pages.product)" class="hover:bg-green-50/30">
                            <td class="px-5 py-4 font-bold text-gray-800">{{item.name}}</td>
                            <td class="px-5 py-4 text-right">{{item.purity}}</td>
                            <td class="px-5 py-4 text-right font-bold text-gray-900">{{item.amount}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="p-4 bg-gray-50 border-t flex justify-between items-center text-[10px] font-bold text-gray-500">
                    <span>Page {{pages.product}} of {{getTotalPages(productSales)}}</span>
                    <div class="flex gap-2">
                        <button [disabled]="pages.product === 1" (click)="changePage('product', -1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Prev</button>
                        <button [disabled]="pages.product >= getTotalPages(productSales)" (click)="changePage('product', 1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Next</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. Assembly Line -->
        <div *ngIf="showAssembly" class="flex flex-col gap-3">
            <h3 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                <span class="w-1.5 h-6 bg-blue-600 rounded-full"></span> Assembly Line Output
            </h3>
            <div class="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
                <table class="w-full text-left text-xs">
                    <thead class="bg-gray-50 border-b border-gray-100 text-[10px] uppercase text-gray-500 font-bold">
                        <tr><th class="px-5 py-4">Stage</th><th class="px-5 py-4 text-right">Input</th><th class="px-5 py-4 text-right">Amount</th></tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let item of getPaginatedData(assemblyLine, pages.assembly)" class="hover:bg-blue-50/30">
                            <td class="px-5 py-4">
                                <div class="flex items-center gap-3">
                                    <span [class]="'w-2 h-2 rounded-full ' + item.color"></span>
                                    <span class="font-bold text-gray-800">{{item.name}}</span>
                                </div>
                            </td>
                            <td class="px-5 py-4 text-right">{{item.weight}}</td>
                            <td class="px-5 py-4 text-right font-bold text-blue-600">{{item.amount}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="p-4 bg-gray-50 border-t flex justify-between items-center text-[10px] font-bold text-gray-500">
                    <span>Page {{pages.assembly}} of {{getTotalPages(assemblyLine)}}</span>
                    <div class="flex gap-2">
                        <button [disabled]="pages.assembly === 1" (click)="changePage('assembly', -1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Prev</button>
                        <button [disabled]="pages.assembly >= getTotalPages(assemblyLine)" (click)="changePage('assembly', 1)" class="p-1 px-3 bg-white border rounded disabled:opacity-50">Next</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>